// extracted by mini-css-extract-plugin
module.exports = {"shadow-none":"FutureDeliveryRequests_shadow-none_OL27I","bg-none":"FutureDeliveryRequests_bg-none_3ndds"};